import { FaTasks, FaUserFriends, FaAward, FaUsersCog } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaTasks />, // Tasks icon
    title: 'Projects Done',
    count: '100',
  },
  {
    id: 2,
    icon: <FaUserFriends />, // User Friends icon
    title: 'Satisfied Clients',
    count: '1000',
  },
  {
    id: 3,
    icon: <FaAward />, // Award icon
    title: 'Awards Won',
    count: '20',
  },
  {
    id: 4,
    icon: <FaUsersCog />, // Users Cog icon
    title: 'Expert Team',
    count: '50',
  },
];

export default counter;